import { useMiniSite } from "../../components/minisite/context";
import { PublicVehicleCard } from "../RentalProfile";
import { Car } from "lucide-react";

export default function MiniSiteFleet() {
  const { data, theme } = useMiniSite();
  const vehicles = data.vehicles || [];

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="ms-fleet-page">
      <h1 className="font-display text-3xl sm:text-4xl font-bold" style={{ color: theme }}>
        Our fleet
      </h1>
      <p className="text-sm text-slate-600 mt-1">
        {vehicles.length} rental{vehicles.length === 1 ? "" : "s"} currently published.
      </p>

      {vehicles.length === 0 ? (
        <div className="mt-8 rounded-xl border border-dashed border-slate-300 bg-slate-50 p-10 text-center text-slate-500" data-testid="ms-fleet-empty">
          <Car className="w-8 h-8 mx-auto mb-2 text-slate-400" />
          The business hasn&apos;t published any vehicles yet.
        </div>
      ) : (
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="ms-fleet-grid">
          {vehicles.map((v) => (
            <PublicVehicleCard key={v.id} companyId={data.id} vehicle={v} />
          ))}
        </div>
      )}
    </div>
  );
}
